var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15536_65908)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.3332 9.99935C18.3332 5.39697 14.6022 1.66602 9.99984 1.66602C5.39746 1.66602 1.6665 5.39697 1.6665 9.99935C1.6665 14.6017 5.39746 18.3327 9.99984 18.3327C14.6022 18.3327 18.3332 14.6017 18.3332 9.99935Z",
    stroke: "#616874",
    strokeWidth: 1.67
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 10.4167L8.74984 12.5L13.3332 7.5",
    stroke: "#616874",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15536_65908"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompleted);
export default __webpack_public_path__ + "static/media/completed.cc229c620fe6cbecc673929a95083b8f.svg";
export { ForwardRef as ReactComponent };